import { all, call, put, select } from 'redux-saga/effects';

import * as invoiceService from '../../resource/invoice/invoice.saga-service';
import { IInvoiceListResult } from '../../resource/invoice/invoice.types';
import * as subscriptionService from '../../resource/subscription/subscription.saga-service';
import * as pageStateService from '../page-state/page-state.saga-services';
import * as actions from './invoices.actions';
import * as types from './invoices.types';
import { invoicesPageSelectors } from './invoices.selectors';

export function* fetchInvoices(payload: types.IFetchInvoicesPayload = {}) {
  const currentLimit = (yield select(invoicesPageSelectors.selectInvoicesLimit)) as number;
  const page = payload.page ?? 1;
  const limit = payload.limit ?? currentLimit;

  const response = (yield call(invoiceService.getInvoices, page, limit)) as IInvoiceListResult | null;
  if (!response) {
    return;
  }

  yield put(
    actions.storeInvoicesList({
      invoiceIds: response.items.map((invoice) => invoice.id),
      page: response.page,
      limit: response.limit,
      total: response.total,
      totalPages: response.totalPages,
    }),
  );
}

export function* clearInvoicesPageStorage() {
  yield put(actions.clearInvoicesPage());
}

export function* fetchInvoiceDetail(invoiceId: string) {
  yield call(pageStateService.initPage, 'invoiceDetail');
  yield all([call(invoiceService.getInvoiceById, invoiceId), call(subscriptionService.getSubscription)]);
  yield call(pageStateService.completedInit, 'invoiceDetail');
}
